import React from 'react';
import { VocabularyEntry } from '../types/game';

interface VocabularyResultsProps {
  vocabularyList: VocabularyEntry[];
}

const convertToCSV = (data: VocabularyEntry[]): string => {
  if (data.length === 0) return "";
  const header = "Word,Meaning,SourceLevel\n";
  const rows = data.map(entry => 
    `"${entry.word}","${entry.meaning}",${entry.sourceLevel}`
  ).join('\n');
  return header + rows;
};

const handleDownload = (list: VocabularyEntry[]) => {
  if (list.length === 0) return;
  
  const csvContent = convertToCSV(list);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  
  link.setAttribute("href", url);
  link.setAttribute("download", "English_Vocab_List.csv");
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const VocabularyResults: React.FC<VocabularyResultsProps> = ({ vocabularyList }) => {
  return (
    <div className="vocabulary-results-panel">
      <h3>我的生词本</h3>
      {vocabularyList.length > 0 ? (
        <>
          <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
              <tr style={{backgroundColor: '#f2f2f2'}}>
                <th style={{padding: '8px', border: '1px solid #ddd'}}>原始单词 (Word)</th>
                <th style={{padding: '8px', border: '1px solid #ddd'}}>对应意思 (Meaning)</th>
              </tr>
            </thead>
            <tbody>
              {vocabularyList.map((entry, index) => (
                <tr key={index} style={{borderBottom: '1px solid #eee'}}>
                  <td style={{padding: '8px'}}>{entry.word}</td>
                  <td style={{padding: '8px'}}>{entry.meaning}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button 
            onClick={() => handleDownload(vocabularyList)}
            style={{marginTop: '20px', padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px'}}
          >
            📥 下载生词本 (CSV)
          </button>
        </>
      ) : (
        <p>本轮游戏您没有添加生词。</p>
      )}
    </div>
  );
};

export default VocabularyResults;
